import { render, staticRenderFns } from "./AnnualincomeInfo.vue?vue&type=template&id=c7a3a87e&scoped=true"
import script from "./AnnualincomeInfo.vue?vue&type=script&lang=js"
export * from "./AnnualincomeInfo.vue?vue&type=script&lang=js"
import style0 from "./AnnualincomeInfo.vue?vue&type=style&index=0&id=c7a3a87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a3a87e",
  null
  
)

export default component.exports